// Where a finished sign-in opens (K11 pt 5.1): on the admin site (admin.beetsol.com) a super admin lands on Workspaces,
// every other sign-in on the dashboard. The sign-in card's password step and the activation page both use it.
export const homeAfterSignIn = (user) => {
  const onAdminSite = window.location.hostname.startsWith('admin.');
  const superAdmin = !!user && (user.super_admin === true || user.super_admin === 1);
  return onAdminSite && superAdmin ? '/workspace' : '/dashboard';
};

export default homeAfterSignIn;
